/**
 *  Reorders array by moving movableItem to another position.
 *  ! NB: Splice does not return modified array -
 *      it modifies array in place and then returns deleted elements, so do not 'return array.splice(...'
 */
export const reorderArray = function(array, movableItemIndex, toIndex) {
  array.splice(toIndex, 0, array.splice(movableItemIndex, 1)[0]);
  return array; // It modifies array in place so no need to use return value.
};
